<template>
    <label class="text-[16px] font-bold leading-6"> {{ text }} <span v-if="require" class="text-[#EF3809] text-[14px] leading-8">*</span></label>
</template>
<script>
export default {
    props: {
        text: String,
        require: Boolean,
    }
}
</script>
